import { isEqual } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';

import { watcherListeners } from './useWatcherProvider';

export const useWatchers = (requestId: number | string) => {
  const [watchers, setWatchers] = useState([]);
  const loophole = useRef(watchers);
  loophole.current = watchers;

  const watcherFilter = useCallback((newWatchers: string[]) => {
    if (!isEqual(loophole.current, newWatchers)) {
      setWatchers(newWatchers);
    }
  }, []);

  useEffect(() => {
    watcherListeners[requestId] ??= [];
    watcherListeners[requestId].push(watcherFilter);
    return () => {
      watcherListeners[requestId] = watcherListeners[requestId].filter((x) => x !== watcherFilter);
    };
  }, [requestId, watcherFilter]);
  return watchers;
};
